let reducers = {
  placeholder: (state = {}) => {
    return state;
  },
};

export default reducers;
